import InputField from './InputField';

// TODO move this into lib folder and get rid of component
function validateEmail(email, isRequired) {
  if (!isRequired && email.length === 0) {
    return true;
  }

  let regex = /[A-Z0-9._%'=+][A-Z0-9._%'=+-]*@([A-Z0-9]([A-Z0-9-]*[A-Z0-9])?\.)+[A-Z]{2,}/iugy;
  return !!(regex.exec(email));
}

export default class EmailField extends InputField {
  validate(input) {
    let validated = super.validate(input);
    return validated && validateEmail(input, this.props.required);
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/FieldComponents/EmailField.jsx
 **/